module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('highscores', {
    on: {
      "click-view-history": function($event) {
        _vm.playbackHistory($event)
      },
      "click-restart": function($event) {
        _vm.restartGame()
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "titlebar"
    }
  }, [_c('h1', [_vm._v("404 - Page not found")]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_vm._v(_vm._s(_vm.currentScore))])]), _vm._v(" "), _c('div', {
    staticClass: "body-container"
  }, [_c('div', {
    staticClass: "game-container"
  }, [_c('game', {
    on: {
      "gameover": function($event) {
        _vm.gameover($event)
      },
      "score-change": function($event) {
        _vm.updateScore($event)
      },
      "candy-placed": function($event) {
        _vm.handleCandyPlaced($event)
      },
      "update": function($event) {
        _vm.handleUpdate($event)
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ae9a8a7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 18
// module chunks = 0